import { TextField } from '@mui/material';
import AdapterJalali from '@date-io/date-fns-jalali';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import {
  MobileDatePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers-pro';
import React from 'react';
import { ConvertDateToJalali } from 'utils/ConvertDateToJalali';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
const SingularDatePicker = ({
  label,
  onChange,
  errors,
  name,
  getter,
  isDateTime = false,
  i18n,
  dashSeperator,
}) => {
  const [value, setValue] = React.useState(new Date());

  const done_msg = FindLangKey(
    'general-public-label-approve'
  );
  const cancel_msg = FindLangKey(
    'general-public-label-dismiss'
  );

  return (
    <LocalizationProvider
      dateAdapter={
        i18n?.language === 'en'
          ? AdapterMoment
          : AdapterJalali
      }
      {...(i18n?.language === 'en'
        ? { adapterLocale: 'en' }
        : {})}
      localeText={{
        okButtonLabel: done_msg,
        cancelButtonLabel: cancel_msg,
      }}
    >
      <MobileDatePicker
        label={label}
        value={value}
        onChange={(newValue) => {
          setValue(newValue);
          !isDateTime &&
            onChange &&
            onChange(ConvertDateToJalali(newValue));
          getter &&
            getter((prev) => ({
              ...prev,
              Date: ConvertDateToJalali(newValue),
            }));
        }}
        renderInput={(params) => {

          return (
            <TextField
              color="colorPrimer"
              {...params}
              fullWidth
              sx={{ marginBlock: '0.2em', width: 'auto' }}
              inputProps={{
                value: params.inputProps.value
                  .split('/')
                  .join('-'),
              }}
            />
          );
        }}
        InputProps={{
          style: {
            maxHeight: '40px',
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default SingularDatePicker;
